import { useEffect, useState } from 'react';
import { NavLink, Route, Routes } from 'react-router-dom';
import { CheckPage } from './pages/CheckPage';
import { DashboardPage } from './pages/DashboardPage';
import { ReportListPage } from './pages/ReportListPage';
import { ReportDetailPage } from './pages/ReportDetailPage';
import { SourcePage } from './pages/SourcePage';
import { IngestionPage } from './pages/IngestionPage';
import { AdminPage } from './pages/AdminPage';
import { ForensicPage } from './pages/ForensicPage';
import { ForensicDetailPage } from './pages/ForensicDetailPage';
import { api } from './api';

interface Me {
  id: string;
  email: string;
  name: string;
}

export function App() {
  const [me, setMe] = useState<Me | null | undefined>(undefined);

  useEffect(() => {
    api.me().then((m) => setMe(m));
  }, []);

  if (me === undefined) {
    return <main><p>Loading…</p></main>;
  }
  if (me === null) {
    return (
      <main>
        <div className="card">
          <h2>Sign in required</h2>
          <p className="muted">Sign in with your Microsoft 365 account to use DMARCheck.</p>
          <p>
            <a href="/auth/login"><button>Sign in with Microsoft</button></a>
          </p>
        </div>
      </main>
    );
  }

  return (
    <>
      <header className="topbar">
        <span className="brand">DMARCheck</span>
        <nav>
          <NavLink to="/" end>Check</NavLink>
          <NavLink to="/dashboard">Dashboard</NavLink>
          <NavLink to="/reports">Reports</NavLink>
          <NavLink to="/forensic">Forensic</NavLink>
          <NavLink to="/ingestion">Ingestion</NavLink>
          <NavLink to="/admin">Admin</NavLink>
        </nav>
        <span className="spacer" />
        <span className="muted">{me.name}</span>
        <button className="secondary" onClick={logout}>Sign out</button>
      </header>
      <main>
        <Routes>
          <Route path="/" element={<CheckPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/reports" element={<ReportListPage />} />
          <Route path="/reports/:id" element={<ReportDetailPage />} />
          <Route path="/forensic" element={<ForensicPage />} />
          <Route path="/forensic/:id" element={<ForensicDetailPage />} />
          <Route path="/source/:ip" element={<SourcePage />} />
          <Route path="/ingestion" element={<IngestionPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </main>
    </>
  );
}

async function logout() {
  const r = await fetch('/auth/logout', { method: 'POST', credentials: 'include' });
  if (r.ok) {
    const data = await r.json();
    window.location.href = data.logoutUrl;
  }
}
